<template>
  <div class="form-group">
    <label>{{config.name}} <span v-if="config.required">*</span></label>
    <select v-on:change="updateSelect" class="form-control"  :class="{ 'is-invalid': errors.length > 0}">
      <option></option>
      <option v-for="option in options" v-bind:key="option.id" :value="option.value">{{option.name}}</option>
    </select>
    <div class="invalid-feedback" :class="{'d-block' : errors.length > 0}"  v-if="errors.length > 0" v-cloak>
      {{ errors[0] }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  config: Object,
  errors: Array,
})

const options = computed(() => {
  return props.config.options.filter(option => option.value !== 'null' && option.value !== '');
});

const emit = defineEmits(['change']);
const updateSelect = (e) => {
  emit('change', e.target.value);
}
</script>